export var GalleryFlow;
(function (GalleryFlow) {
    GalleryFlow["GET_MEDIA_FILES"] = "GetMediaFiles";
    GalleryFlow["GET_MORE_MEDIA_FILES"] = "GetMoreMediaFiles";
})(GalleryFlow || (GalleryFlow = {}));
